(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-drawer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const drawer = document.getElementById('ContactDrawer');
    if (!drawer) return;
    const panel = drawer.querySelector('.contact-drawer__panel');
    const productSelect = drawer.querySelector('#ContactDrawerProduct');
    const tradeFields = drawer.querySelector('[data-trade-fields]');
    let lastFocus = null;

    function open(detail) {
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('contact-drawer-open');
      if (detail && detail.product && productSelect) {
        const opt = Array.from(productSelect.options).find(o => o.value === detail.product);
        if (opt) productSelect.value = detail.product;
      }
      setTimeout(() => panel.focus(), 50);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('contact-drawer-open');
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function(e) {
      const opener = e.target.closest('[data-contact-drawer-open]');
      if (opener) {
        e.preventDefault();
        open({ product: opener.dataset.product });
        return;
      }
      if (e.target.closest('[data-contact-drawer-close]')) {
        e.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    document.addEventListener('contact-drawer:open', function(e) {
      open(e.detail || {});
    });

    drawer.addEventListener('change', function(e) {
      if (e.target.matches('[data-trade-toggle]')) {
        tradeFields.hidden = e.target.dataset.tradeToggle !== 'trade';
      }
    });

    // If submission succeeded (Liquid rendered the success message), reopen the drawer on load.
    if (drawer.querySelector('.contact-drawer__success')) {
      open({});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customise-drawer"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const drawer = document.getElementById('CustomiseDrawer');
    if (!drawer) return;
    const panel = drawer.querySelector('.customise-drawer__panel');
    const productSelect = drawer.querySelector('#CustomiseDrawerProduct');
    const variantInput = drawer.querySelector('#CustomiseDrawerVariant');
    const variantIdInput = drawer.querySelector('#CustomiseDrawerVariantId');
    const pageUrlInput = drawer.querySelector('#CustomiseDrawerPageUrl');
    const prefillHint = drawer.querySelector('[data-prefill-hint]');
    let lastFocus = null;

    function getLiveVariant() {
      // 1. Try the URL ?variant=ID (Shopify updates this when a customer picks a variant)
      const params = new URLSearchParams(location.search);
      const urlVariantId = params.get('variant');

      // 2. Try the product form's hidden id input (most reliable for current selection)
      const formIdInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const formVariantId = formIdInput ? formIdInput.value : null;

      const liveId = formVariantId || urlVariantId;

      // 3. Try to derive a human-readable title from the variant picker.
      // Read the label text associated with each checked input, never the raw value
      // (the value is usually a variant ID, e.g. "5705183854931").
      let liveTitle = '';
      const picker = document.querySelector('variant-picker, [is="variant-picker"]') || document;
      const parts = [];
      picker.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked').forEach(el => {
        let label = '';
        if (el.id) {
          const l = document.querySelector('label[for="' + el.id + '"]');
          if (l) label = l.textContent.trim();
        }
        if (!label) {
          const wrapping = el.closest('label');
          if (wrapping) label = wrapping.textContent.trim();
        }
        if (!label) label = el.dataset.optionValue || el.getAttribute('aria-label') || '';
        // Final fallback: only use value if it isn't purely numeric (which would be a variant ID)
        if (!label && el.value && !/^\d+$/.test(el.value)) label = el.value.trim();
        if (label) parts.push(label);
      });
      picker.querySelectorAll('select').forEach(el => {
        if (el.selectedOptions[0]) {
          const text = el.selectedOptions[0].text.trim();
          if (text && !/^\d+$/.test(text)) parts.push(text);
        }
      });
      liveTitle = parts.filter(Boolean).join(' / ');

      return { id: liveId, title: liveTitle };
    }

    function open(detail) {
      lastFocus = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('customise-drawer-open');

      const live = getLiveVariant();

      let prefilled = false;
      if (detail && detail.product && productSelect) {
        const opt = Array.from(productSelect.options).find(o => o.value === detail.product);
        if (opt) {
          productSelect.value = detail.product;
          prefilled = true;
        }
      }
      if (variantInput) {
        const v = live.title || (detail && detail.variant) || '';
        variantInput.value = (v && v !== 'Default Title') ? v : '';
      }
      if (variantIdInput) {
        variantIdInput.value = live.id || (detail && detail.variantId) || '';
      }
      if (pageUrlInput) {
        pageUrlInput.value = (detail && detail.pageUrl) ? detail.pageUrl : (location.pathname + location.search);
      }
      if (prefillHint) prefillHint.hidden = !prefilled;

      setTimeout(() => panel.focus(), 50);
    }
    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('customise-drawer-open');
      if (lastFocus) lastFocus.focus();
    }

    document.addEventListener('click', function(e) {
      const opener = e.target.closest('[data-customise-drawer-open]');
      if (opener) {
        e.preventDefault();
        if (opener.tagName === 'DETAILS') opener.removeAttribute('open');
        // Release focus so the brown :focus-visible state doesn't latch
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
          document.activeElement.blur();
        }
        open({
          product: opener.dataset.product,
          variant: opener.dataset.variant,
          variantId: opener.dataset.variantId,
          pageUrl: opener.dataset.pageUrl
        });
        return;
      }
      if (e.target.closest('[data-customise-drawer-close]')) {
        e.preventDefault();
        close();
      }
    });

    // Prevent native <details> toggle on the trigger and handle keyboard activation
    document.querySelectorAll('details.customise-trigger').forEach(function(d) {
      d.addEventListener('toggle', function() { if (d.open) d.removeAttribute('open'); });
      const summary = d.querySelector('summary');
      if (summary) {
        summary.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            open({
              product: d.dataset.product,
              variant: d.dataset.variant,
              variantId: d.dataset.variantId,
              pageUrl: d.dataset.pageUrl
            });
          }
        });
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
    });

    document.addEventListener('customise-drawer:open', function(e) {
      open(e.detail || {});
    });

    if (drawer.querySelector('.customise-drawer__success')) {
      open({});
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
